module.exports = __webpack_public_path__ + "02ce7ac9f295c866630830e6575aebaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/works/Carousel_Gnade-Donau-Gnade.jpg
// module id = 875
// module chunks = 0